module.exports = __webpack_public_path__ + "img/hero-1.b66a2eb5.png";